import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { OfferBulkActionsEffects } from './store/bulk-actions/bulk-actions.effects';
import { OfferBulkNamespace, OfferBulkReducer } from './store/bulk-actions/bulk-actions.store';
import { JobEvaluationFormsEffects } from './store/job-evaluation-forms/job-evaluation-forms.effects';
import {
  JobEvaluationFormsNamespace,
  JobEvaluationFormsReducer,
} from './store/job-evaluation-forms/job-evaluation-forms.store';
import { JobMatchingPlacementsEffects } from './store/job-matching-placements/job-matching-placements.effects';
import {
  JobMatchingPlacementsNamespace,
  JobMatchingPlacementsReducer,
} from './store/job-matching-placements/job-matching-placements.store';
import { JobRequisitionsEffects } from './store/job-requisitions/job-requisitions.effects';
import {
  JobRequisitionsNamespace,
  JobRequisitionsReducer,
} from './store/job-requisitions/job-requisitions.store';
import { JobWorkflowAutomationsEffects } from './store/job-workflow-automations/job-workflow-automations.effects';
import {
  JobWorkflowAutomationsNamespace,
  JobWorkflowAutomationsReducer,
} from './store/job-workflow-automations/job-workflow-automations.store';
import { JobsBasicEffects } from './store/jobs/jobs-basic/jobs-basic.effects';
import { JobsBasicNamespace, JobsBasicReducer } from './store/jobs/jobs-basic/jobs-basic.store';
import { JobsBriefEffects } from './store/jobs/jobs-brief/jobs-brief.effects';
import { JobsBriefANamespace, JobsBriefReducer } from './store/jobs/jobs-brief/jobs-brief.store';
import { JobsFullEffects } from './store/jobs/jobs-full/jobs-full.effects';
import { JobsFullNamespace, JobsFullReducer } from './store/jobs/jobs-full/jobs-full.store';
import { JobsItemEffects } from './store/jobs/jobs-item/jobs-item.effects';
import { JobItemsNamespace, JobItemsReducer } from './store/jobs/jobs-item/jobs-item.store';
import { JobsWrapperEffects } from './store/jobs/jobs-wrapper/jobs-wrapper.effects';
import { OfferContentGeneratorEffects } from './store/offer-content-generator/offer-content-generator.effects';
import {
  OfferContentGeneratorNamespace,
  OfferContentGeneratorReducer,
} from './store/offer-content-generator/offer-content-generator.store';
import { OfferLanguagesEffects } from './store/offer-languages/offer-languages.effects';
import {
  OfferLanguagesNamespace,
  OfferLanguagesReducer,
} from './store/offer-languages/offer-languages.store';
import { OfferTranslationsEffects } from './store/offer-translations/offer-translations.effects';
import {
  OfferTranslationsNamespace,
  OfferTranslationsReducer,
} from './store/offer-translations/offer-translations.store';
import { OffersByCompanyEffects } from './store/offers-by-company/offers-by-company.effects';
import {
  OffersByCompanyNamespace,
  OffersByCompanyReducer,
} from './store/offers-by-company/offers-by-company.store';
import { OffersGlobalEffects } from './store/offers-global.effects';
import { PipelineStagesEffects } from './store/pipeline-stages/pipeline-stages.effects';
import {
  PipelineStagesNamespace,
  PipelineStagesReducer,
} from './store/pipeline-stages/pipeline-stages.store';
import { PlacementsWithoutOpeningsEffects } from './store/placements-without-openings/placements-without-openings.effects';
import {
  PlacementsWithoutOpeningsNamespace,
  PlacementsWithoutOpeningsReducer,
} from './store/placements-without-openings/placements-without-openings.store';
import { StageNamespace, StageReducer } from './store/stages.store';

@NgModule({
  imports: [
    StoreModule.forFeature(JobItemsNamespace, JobItemsReducer),
    StoreModule.forFeature(JobsBriefANamespace, JobsBriefReducer),
    StoreModule.forFeature(JobsBasicNamespace, JobsBasicReducer),
    StoreModule.forFeature(JobsFullNamespace, JobsFullReducer),
    StoreModule.forFeature(OfferLanguagesNamespace, OfferLanguagesReducer),
    StoreModule.forFeature(OffersByCompanyNamespace, OffersByCompanyReducer),
    StoreModule.forFeature(PipelineStagesNamespace, PipelineStagesReducer),
    StoreModule.forFeature(StageNamespace, StageReducer),
    StoreModule.forFeature(OfferBulkNamespace, OfferBulkReducer),
    StoreModule.forFeature(JobRequisitionsNamespace, JobRequisitionsReducer),
    StoreModule.forFeature(PlacementsWithoutOpeningsNamespace, PlacementsWithoutOpeningsReducer),
    StoreModule.forFeature(OfferContentGeneratorNamespace, OfferContentGeneratorReducer),
    StoreModule.forFeature(OfferTranslationsNamespace, OfferTranslationsReducer),
    StoreModule.forFeature(JobWorkflowAutomationsNamespace, JobWorkflowAutomationsReducer),
    StoreModule.forFeature(JobEvaluationFormsNamespace, JobEvaluationFormsReducer),
    StoreModule.forFeature(JobMatchingPlacementsNamespace, JobMatchingPlacementsReducer),
    EffectsModule.forFeature([
      JobsItemEffects,
      JobsBriefEffects,
      JobsBasicEffects,
      JobsFullEffects,
      OfferLanguagesEffects,
      JobsWrapperEffects,
      OffersByCompanyEffects,
      PipelineStagesEffects,
      OfferBulkActionsEffects,
      OffersGlobalEffects,
      JobRequisitionsEffects,
      PlacementsWithoutOpeningsEffects,
      OfferContentGeneratorEffects,
      OfferTranslationsEffects,
      JobWorkflowAutomationsEffects,
      JobEvaluationFormsEffects,
      JobMatchingPlacementsEffects,
    ]),
  ],
})
export class OffersDataModule {}
